import * as tslib_1 from "tslib";
import { GraphQueryableInstance, GraphQueryableCollection, defaultPath } from "./graphqueryable";
import { jsS } from "@pnp/common";
var Attachments = /** @class */ (function (_super) {
    tslib_1.__extends(Attachments, _super);
    function Attachments() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Gets a member of the group by id
     *
     * @param id Attachment id
     */
    Attachments.prototype.getById = function (id) {
        return new Attachment(this, id);
    };
    /**
     * Add attachment to this collection
     *
     * @param name Name given to the attachment file
     * @param bytes File content
     */
    Attachments.prototype.addFile = function (name, bytes) {
        return this.postCore({
            body: jsS({
                "@odata.type": "#microsoft.graph.fileAttachment",
                contentBytes: bytes,
                name: name,
            }),
        });
    };
    Attachments = tslib_1.__decorate([
        defaultPath("attachments")
    ], Attachments);
    return Attachments;
}(GraphQueryableCollection));
export { Attachments };
var Attachment = /** @class */ (function (_super) {
    tslib_1.__extends(Attachment, _super);
    function Attachment() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Attachment;
}(GraphQueryableInstance));
export { Attachment };
//# sourceMappingURL=attachments.js.map